import { Injectable } from '@angular/core';
import { AlertButton, AlertController, AlertInput, AlertOptions } from '@ionic/angular';
import { DismissRolesEnum } from '@enums';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor(private alertCtrl: AlertController) {}

  /**
   * @description Crear una alerta simple.
   * @param header Titulo de la alerta
   * @param message Contenido de la alerta
   * @param buttons Botones de la alerta, si se omiten se pondra un boton de OK por defecto
   */
  public async simpleAlert(
    header?: string,
    message?: string,
    buttons: string[] | AlertButton[] = [],
    backdropDismiss: boolean = true
  ): Promise<HTMLIonAlertElement> {
    const alertOpts: AlertOptions = {
      cssClass: 'anp-alert',
      backdropDismiss,
      mode: 'ios'
    };

    const defaultButton: AlertButton[] = [
      {
        text: 'Entendido',
        role: DismissRolesEnum.ACCEPT
      }
    ];

    alertOpts.header = header;
    alertOpts.message = message;
    alertOpts.buttons = buttons.length ? buttons : defaultButton;

    const alert = await this.alertCtrl.create(alertOpts);

    await alert.present();

    return alert;
  }

  /**
   * @description Crear una alerta con campos de formulario.
   * @param header Titulo de la alerta
   * @param inputs Los campos del formulario
   * @param buttons Botones de la alerta, si se omiten se pondran botones de Aceptar y Cancelar por defecto
   */
  public async inputAlert(
    header: string,
    inputs: AlertInput[],
    buttons?: string[] | AlertButton[],
    backdropDismiss: boolean = true
  ): Promise<HTMLIonAlertElement> {
    const alertOpt: AlertOptions = {
      cssClass: 'anp-alert',
      backdropDismiss
    };

    alertOpt.header = header;
    alertOpt.inputs = inputs;

    const defaultButtons: AlertButton[] = [
      {
        text: 'Aceptar',
        role: DismissRolesEnum.ACCEPT
      },
      {
        text: 'Cancelar',
        role: DismissRolesEnum.CANCEL
      }
    ];

    alertOpt.buttons = buttons || defaultButtons;

    const alert = await this.alertCtrl.create(alertOpt);

    await alert.present();

    return alert;
  }
}
